import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { iconoirNavArrowDown } from "@ng-icons/iconoir";
import { NgxMaskDirective } from "ngx-mask";
import { SharedModule } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-input-text",
  standalone: true,
  imports: [
    CommonModule,
    InputTextModule,
    ReactiveFormsModule,
    FormsModule,
    DropdownModule,
    NgIconComponent,
    ProgressSpinnerModule,
    SharedModule,
    NgxMaskDirective,
  ],
  providers: [provideIcons({ iconoirNavArrowDown })],
  templateUrl: "./input-text.component.html",
})
export class InputTextComponent {
  @Output() whenFocused = new EventEmitter<string>();

  @Input() emitOnFocus = false;
  @Input() form: FormGroup | null = null;
  @Input() name: string | number = "";
  @Input() label = "";
  @Input() styleClass = "";
  @Input() widthClass = "w-full";
  @Input() labelClass = "";
  @Input() type: "text" | "email" = "text";
  @Input() errors = "";
  @Input() required = false;
  @Input() direction: "row" | "col" = "col";
  @Input() loading = false;
  @Input() mask = "";
  @Input() placeholder = "";
  protected readonly Number = Number;
  protected readonly toString = toString;

  keydown(event: KeyboardEvent) {
    const elem = event.target as HTMLInputElement;
    if (
      (!elem.value && event.code === "Space") ||
      (event.code === "Space" && elem.value[elem.value.length - 1] === " ")
    ) {
      event.preventDefault();
    }
  }
}
